import React, { useCallback } from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { useTheme } from '../theme/ThemeContext';

const ParticleBackground = () => {
    const { mode } = useTheme();

    const particlesInit = useCallback(async (engine) => {
        await loadSlim(engine);
    }, []);

    const particlesOptions = {
        fullScreen: {
            enable: true,
            zIndex: 0, // Behind content but in front of backgrounds
        },
        background: {
            color: {
                value: "transparent",
            },
        },
        fpsLimit: 60,
        interactivity: {
            events: {
                onClick: {
                    enable: true,
                    mode: "push",
                },
                onHover: {
                    enable: true,
                    mode: "repulse",
                },
                resize: true,
            },
            modes: {
                push: {
                    quantity: 4,
                },
                repulse: {
                    distance: 200,
                    duration: 0.4,
                },
            },
        },
        particles: {
            color: {
                value: mode === 'light' ? "#000000" : "#FFFFFF",
            },
            links: {
                color: mode === 'light' ? "#000000" : "#FFFFFF",
                distance: 250,
                enable: true,
                opacity: 0.2, // More subtle link opacity
                width: 0.8, // Thinner lines
            },
            collisions: {
                enable: true,
            },
            move: {
                direction: "none",
                enable: true,
                outModes: {
                    default: "bounce",
                },
                random: false,
                speed: 0.3,  // Much slower, subtle movement
                straight: false,
            },
            number: {
                density: {
                    enable: true,
                    area: 1200, // Balanced spread
                },
                value: 50, // Medium density
            },
            opacity: {
                value: 0.3, // Lower base opacity
                anim: {
                    enable: true,
                    speed: 0.15, // Very slow fade animation
                    opacity_min: 0.1, // Lower minimum opacity
                    sync: false
                }
            },
            shape: {
                type: "circle",
            },
            size: {
                value: { min: 1, max: 3 }, // Slightly smaller
            },
        },
        detectRetina: true,
    };

    return (
        <Particles
            id="tsparticles"
            init={particlesInit}
            options={particlesOptions}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 0,
            }}
        />
    );
};

export default ParticleBackground;
